import React from 'react';
import { Grid } from '@mui/material';
import classNames from 'classnames';
import { getVersionBrowserColoringClass } from '../../../versionBrowser/utils';
var DetailInlineGroup = function (_a) {
    var childGridSizes = _a.childGridSizes, indentLeft = _a.indentLeft, indentRight = _a.indentRight, children = _a.children, coloring = _a.coloring, className = _a.className;
    return (React.createElement(Grid, { className: classNames('detailInlineGroup', className, getVersionBrowserColoringClass(coloring), {
            'detailInlineGroup--indentLeft': indentLeft,
            'detailInlineGroup--indentRight': indentRight
        }), container: true, spacing: 2, justifyContent: 'space-between' }, React.Children.map(children, function (child, i) {
        return React.createElement(Grid, { key: i, xs: (childGridSizes && childGridSizes[i]) ? childGridSizes[i] : true, item: true, className: 'detailInlineGroup__item' }, child);
    })));
};
export default DetailInlineGroup;
//# sourceMappingURL=DetailInlineGroup.js.map